import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import auth from "../store/modules/system/Auth.js"
import mail from "@/store/modules/system/Mail.js"
import user from "@/store/modules/system/User.js"

import actions from "@/store/actions.js"
import getters from "@/store/getters.js"
import mutations from "@/store/mutations.js"

export default new Vuex.Store({
	state: {
		view: "user",
		colors:  ['#5568F1',"#FF5555", "#dbdbfc", "green" ],
	},
	modules: {auth, mail, user },
	mutations: mutations,
	actions: actions,
	getters: getters
})

